"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import useStore from "@/store/useStore";
import Image from "next/image";
import FadeTransition from "@/components/ui/fade-transition";

export default function Page() {
  const router = useRouter();
  const session = useStore((state) => state.session);
  const [show, setShow] = useState(true);

  // Basic emergency redirect if page gets stuck
  useEffect(() => {
    const fallbackTimeout = setTimeout(() => {
      // If we're still on this page after 4 seconds, redirect to onboarding
      setShow(false);
      router.replace("/onboarding");
    }, 4000);

    return () => clearTimeout(fallbackTimeout);
  }, [router]);

  // Handle session changes
  useEffect(() => {
    // If we have a user session, go to spaces
    if (session?.user) {
      setShow(false);
      router.replace("/user/spaces");
    }
    // If explicitly not logged in (session is null), go to onboarding
    else if (session === null) {
      setShow(false);
      router.replace("/onboarding");
    }
  }, [router, session]);

  return (
    <FadeTransition show={show}>
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-white">
        <div className="animate-pulse">
          <Image
            src="/logos/purple.svg"
            alt="Qensa Logo"
            width={240}
            height={60}
            priority
          />
        </div>
      </div>
    </FadeTransition>
  );
}
